import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './bpi.css'
import App from './App.vue'
import router from './router'
import store from './store'
import titleMixin from './mixins/titleMixin'
import moment from 'moment'
import Popover from 'vue-js-popover'


Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(VueApexCharts)
Vue.use(Popover)
Vue.component('apexchart', VueApexCharts)
Vue.mixin(titleMixin)
Vue.prototype.moment = moment

new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app')
